/**
 * Theme mode — wybór palety dla CMS frontendu.
 *
 * - `light` (default) — paleta jasna w `templates/{symbol}/theme-light.css`
 * - `dark`            — paleta ciemna w `templates/{symbol}/theme-dark.css`
 * - `hc`              — high contrast (WCAG AAA) w `templates/{symbol}/theme-hc.css`
 * - `funeral`         — tryb żałobny (cała strona w odcieniach szarości,
 *                       `filter: grayscale(1)`) w `templates/{symbol}/theme-funeral.css`.
 *                       Template-agnostic — działa identycznie niezależnie od palety
 *                       templatu (filter desaturuje wszystko: tła, obrazy, logo, ikony).
 *
 * Każdy template (zob. `lib/templates/registry.ts`) ma osobne pliki CSS
 * scoped przez `:root[data-template="{symbol}"][data-theme="{mode}"]`.
 *
 * Zmiana motywu nadpisuje TYLKO wartości CSS variables (i opcjonalnie filter) —
 * komponenty bez zmian, układ bez zmian. Atrybut `data-theme` ustawiany na
 * `<html>` w root layout (Server Component, czyta z cookie `cms_theme`).
 *
 * Atrybut `data-template` jest ustawiany niezależnie (z `cms-config.template_symbol`
 * per-domena) — kombinacja obu attrs decyduje który zestaw tokens jest aktywny.
 *
 * Admin top bar (`[data-imperial-admin]`) i setup wizard (`/setup/*`) NIE
 * reagują na te attrs — admin zawsze dark navy, setup zawsze brand instalera.
 *
 * @see ../templates/types.ts — TemplateSymbol, TemplateMetadata
 * @see ../../.claude/CLAUDE.md sekcja "Tryby motywu (light / dark / hc / funeral)"
 */

export type ThemeMode = "light" | "dark" | "hc" | "funeral";

export const COOKIE_THEME = "cms_theme";

export function isThemeMode(value: unknown): value is ThemeMode {
  return value === "light" || value === "dark" || value === "hc" || value === "funeral";
}
